var langEng = {
	navi: {
		home: "Home",
		listing: "Listing",
		cart: "Cart",
		wishList:"Wish List",
		orders: "Orders",
		about: "About Us",
		login: "Login",
		account: "Account",
		logout:"Logout",
		dashboard:"Dashboard",
		location:"Location"
	},
	register: {
		misMatchPassword: "Password MisMatch",
		missingValue: "Missing Values"
	},
	login: {
		login: "Login",
		register: "Register",
		newRegister: "New Register",
		email: "Email",
		password: "Password",
		confirmPassword: "Confirm Password",
		cancel: "Cancel",
		forgotAccountPassword: "Forgot Account/Password",
		givenName: "Given Name",
		surName: "Surname",
		forgotTitle: "Forgot Login",
		forgotInstruction: "Enter your login email and we will send you reset instructions.",
		sendReset: "Send Reset",
		sendResetInProgress: "Sending...",
		backToLogin: "Back to Login",
		enterEmail: "Please enter your login email",
		resetSuccess: "Reset instructions have been sent to your email.",
		resetFailed: "Unable to reset your account. Please try again."
	},
	cart: {
		selectAll: "Select All",
		unselectAll: "Unselect All",
		selectAddress: "Select Address",
		selectContact:"Select Contact",
		submitOrder: "Submit Order",
		terms: "Terms and Policies"
	},
	common: {
		remove:"Remove",
		update:"Update",
		create:"Create",
		select: "Select",
		main:"Main",
		website:"Website",
		shopConfigs:"Configs",
		infoType:"Info Type",
		infoConfigs:"Info Configs",
		qaReply:"QA Reply",
		shopIntro:"Shop Introduction",
		shops:"Site List",
		shopInfo:"Site Mgt",
		shopState:"Site State",
		shopName:"Site Name",
		shopCode:"Site Code",
		domainName:"Domain Name",
		refresh: "Refresh",
		name: "Name",
		pickup: "Pick up",
		phone: "Phone",
		pickupLocation: "Pickup Location",
		phoneAreaNo: "Phone Area",
		city: "City",
		date: "Date",
		add: "Add",
		success: "Success",
		fail: "Fail",
		pleaseLogin: "Please Login",
		pleaseRetry: "Please retry",
		confirm: "Confirm",
		cancel: "Cancel",
		share: "Share",
		copyUrl: "Copy Url",
		extLogin: "External Logins",
		terms: "Terms and Policies",
		noData: "No Data",
		removeFilter: "Remove Filter",
		keyword: "Keyword",
		tags: "Tags",
		categories: "Categories",
		showAll: "Show All",
		search: "Search",
		addToCart: "Add to Cart",
		addToWishList:"Add to Wish List",
		price: "Price",
		quant: "Quantity",
		edit:"Edit",
		shop:"Shop",
		seq:"Seq",
		content:"Content",
		sorting:"Sorting",
		update:"Update",
		delete:"Delete",
		back:"Back",
		updateLocation:"Update Location",
		findDevice:"Find Device",
		saveLocation:"Save Location",
		savedLocations:"Saved Locations",
		selectBuilding:"Select Building",
		getLocation:"Get Location",
		selectCategory:"Select Category",
		userList:"User List"
	},
	contact: {
		newAddress: "New Address",
		newContact:"New Contact",
		addressRemark: "Address Remark (Example: Office/Home)",
		contactName: "Contact Person",
		deliveryAddress: "Delivery Address",
		wrongContactValue: "Wrong Contact Values",
		wrongAddressValue: "Wrong Address Values",
		wrongPickupValue: "Wrong Pickup Values",
		selectPickupLocation: "Please Select Pick up Location"
	},
	order: {
		order: "Order",
		orderNum: "Order Num",
		detail: "Order Detail",
		buyerMsg: "User Message",
		shopMsg: "Shop Reply",
		total: "Total",
		payMethods: "Pay Methods",
		cashOnDelivery: "Cash on Delivery",
		payByFps: "FPS Payment",
		payByPayMe: "PayMe Payment",
		payByAlipay: "Alipay Payment",
		payByWechatpay: "Wechat Pay Payment",
		payByAtm: "Bank Transfer",
		selectedPayment: "Selected Payment",
		isReady:"is ready"
	},
	itemDetail: {
		cart: "Cart",
		continue: "Continue Shopping",
		select: "Select",
		description: "Description",
		specs: "Specs",
		tags: "Tags",
		addToCart: "Add to Cart",
		price: "Price",
		quant: "Quantity",
		selectAllProperty: "Please select all properties"
	},
	shopsList:{
		search:"Search",
		clear:"Clear",
		refresh:"Refresh"
	},
	postList:{
		add:"Add Post +",
		addChild:"Add Child Post +",
		postFilter:"Post Filter",
		shop:"Shop",
		showAll:"Show All"
	},
	postEditor:{
		posts:"Posts",
		postbase:"Basic",
		image:"Image",
		imageAndContent:"Image/Content",
		prices:"Prices",
		labels:"Labels",
		others:"Others",
		title:"Title",
		seq:"Seq",
		content:"Content",
		public:"Public",
		update:"Update",
		childPosts:"Supplementaries",
		cancelEdit:"Cancel Edit",
		tags:"Tags",
		categoryLabels:"Labels",
		loadLinks:"Load Links",
		links:"Links",
		more:"More",
		video:"Video",
		selectFile:"Select File/Image",
		dropFile:"Drop File/Image",
		updateFail:"Update Failed",
		updateFail_8000:"Missing Title/Content",
		updateFail_8001:"Item not found",
		updateFail_8002:"Missing picture",
		updateFail_8003:"Missing category",
		updateFail_8004:"Missing price",
		updateFail_8005:"No Tag",
		updateFail_8006:"Missing Tag",
		updateFail_8007:"No Label",
		updateFail_8008:"Missing Label",
		updateFail_8009:"Label wrong data type"
	},
	postPrices:{
		set:"Set",
		price:"Price",
		cost:"Cost",
		updatePrices:"Update Prices",
		properties:"Properties"
	},
	postProps:{
		edit:"Edit",
		newProp:"New Property",
		properties:"Properties(eg: Size/Color)",
		updateProperties:"Update Properties"
	},
	postLink:{
		linkType:"Linke Type",
		linkUrl:"Link Url",
		linkTitle:"Link Title",
		web:"Website",
		youtubeLink:"Youtube Link",
		setImage:"Set Image"
	},
	category:{
		name:"Name",
		createUnder:"Create Under",
		editingCategory:"Editing Category",
		setState:"Set State",
		createNewNode:"Create New Node",
		add:"Add",
		edit:"Edit"
	}
}

export default langEng;